export default class ByteUtils {
  /**
   * @param {number} byteLength
   * @param {(view: DataView) => void} [init]
   * @returns {Uint8Array}
   */
  static allocate(byteLength, init) {
    const buffer = new ArrayBuffer(byteLength);

    if (typeof init === 'function') {
      const view = new DataView(buffer);
      init(view);
    }

    return new Uint8Array(buffer);
  }

  /**
   * @param {number} value
   * @returns {Uint8Array}
   */
  static u8(value) {
    return ByteUtils.allocate(1, (view) => view.setUint8(0, value));
  }

  /**
   * @param {number} value
   * @returns {Uint8Array}
   */
  static i8(value) {
    return ByteUtils.allocate(1, (view) => view.setInt8(0, value));
  }

  /**
   * @param {number} value
   * @param {boolean} [littleEndian]
   * @returns {Uint8Array}
   */
  static u16(value, littleEndian = false) {
    return ByteUtils.allocate(2, (view) => view.setUint16(0, value, littleEndian));
  }

  /**
   * @param {number} value
   * @param {boolean} [littleEndian]
   * @returns {Uint8Array}
   */
  static i16(value, littleEndian = false) {
    return ByteUtils.allocate(2, (view) => view.setInt16(0, value, littleEndian));
  }

  /**
   * @param {number} value
   * @param {boolean} [littleEndian]
   * @returns {Uint8Array}
   */
  static u32(value, littleEndian = false) {
    return ByteUtils.allocate(4, (view) => view.setUint32(0, value, littleEndian));
  }

  /**
   * @param {number} value
   * @param {boolean} [littleEndian]
   * @returns {Uint8Array}
   */
  static i32(value, littleEndian = false) {
    return ByteUtils.allocate(4, (view) => view.setInt32(0, value, littleEndian));
  }

  /**
   * @param {bigint} value
   * @param {boolean} [littleEndian]
   * @returns {Uint8Array}
   */
  static u64(value, littleEndian = false) {
    return ByteUtils.allocate(8, (view) => view.setBigUint64(0, value, littleEndian));
  }

  /**
   * @param {bigint} value
   * @param {boolean} [littleEndian]
   * @returns {Uint8Array}
   */
  static i64(value, littleEndian = false) {
    return ByteUtils.allocate(8, (view) => view.setBigInt64(0, value, littleEndian));
  }

  /**
   * @param {number} value
   * @param {boolean} [littleEndian]
   * @returns {Uint8Array}
   */
  static f16(value, littleEndian = false) {
    return ByteUtils.allocate(2, (view) => view.setFloat16(0, value, littleEndian));
  }

  /**
   * @param {number} value
   * @param {boolean} [littleEndian]
   * @returns {Uint8Array}
   */
  static f32(value, littleEndian = false) {
    return ByteUtils.allocate(4, (view) => view.setFloat32(0, value, littleEndian));
  }

  /**
   * @param {number} value
   * @param {boolean} [littleEndian]
   * @returns {Uint8Array}
   */
  static f64(value, littleEndian = false) {
    return ByteUtils.allocate(8, (view) => view.setFloat64(0, value, littleEndian));
  }
}
